import { render } from "./EditorCommission.vue?vue&type=template&id=37b69e16&scoped=true"
import script from "./EditorCommission.vue?vue&type=script&lang=js"
export * from "./EditorCommission.vue?vue&type=script&lang=js"

import "./EditorCommission.vue?vue&type=style&index=0&id=37b69e16&lang=scss&scoped=true"

import exportComponent from "/Users/adostos/wame/zealy-web-2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37b69e16"]])

export default __exports__